import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { StoreInfoService } from 'src/app/store-info.service';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Component({
  selector: 'app-generate-content-queue-indicator',
  templateUrl: './generate-content-queue-indicator.component.html',
  styleUrls: ['./generate-content-queue-indicator.component.scss'],
})
export class GenerateContentQueueIndicatorComponent implements OnInit, OnDestroy {
  expanded = false;

  storeInfo: any = null;
  list: any[] = [];
  total = 0;
  done = 0;
  completed = 0;
  inProgress = false;

  dragPosition = { x: 0, y: 0 };

  private sub: Subscription | null = null;

  constructor(
    private storeInfoService: StoreInfoService,
    public utils: UtilitiesService,
  ) {}

  ngOnInit(): void {
    this.sub = this.storeInfoService.storeInfo$.subscribe((info) => {
      if (!info) {
        return;
      }

      this.storeInfo = info;
      this.list = Array.isArray(info?.generate_ai_content_status)
        ? info.generate_ai_content_status
        : [];
      this.total = this.list.length;
      this.done = this.list.filter((x) => x?.status === 'DONE').length;
      this.completed = this.list.filter(
        (x) => x?.status === 'DONE' || x?.status === 'FAILED',
      ).length;
      const status = info?.generate_ai_content_status_summary?.status;
      this.inProgress = status === 'QUEUE' || status === 'PROCESSING';

      if (!this.inProgress) {
        this.expanded = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
      this.sub = null;
    }
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  collapse(): void {
    this.expanded = false;
  }

  getIndicatorText(): string {
    const curr = Math.min(this.completed, this.total);
    return this.utils.translate('Generating Content {0}/{1}', [curr, this.total]);
  }

  getTopicLabel(topic: string): string {
    const mapper = {
      DIRECTIONS_FOR_USE: 'Directions for Use',
      INGREDIENTS: 'Ingredients',
      PRODUCT_DESCRIPTION: 'Product Description',
      PRODUCT_FAQS: 'Product FAQs',
      PRODUCT_OVERVIEW: 'Product Overview',
      PRODUCT_SEO: 'Product SEO',
      STORE_GLOBAL_SEO: 'Store Global SEO',
    };

    const label = mapper[topic] ?? (topic || '').replace(/_/g, ' ');
    return this.utils.translate(label);
  }

  getStatusLabel(status: string): string {
    const mapper = {
      QUEUE: 'Queued',
      PROCESSING: 'Generating',
      DONE: 'Completed',
      FAILED: 'Failed',
    };
    return this.utils.translate(mapper[status] ?? status);
  }

  getStatusIconClass(status: string): string {
    if (status === 'DONE') return 'fi fi-rr-check text-green-600';
    if (status === 'FAILED') return 'fi fi-rr-cross-circle text-rose-600';
    if (status === 'PROCESSING') return 'fi fi-rr-refresh text-cyan-600';
    return 'fi fi-rr-time-forward text-amber-600';
  }

  getStatusBadgeClass(status: string): string {
    if (status === 'DONE') return 'badge--done';
    if (status === 'FAILED') return 'badge--failed';
    if (status === 'PROCESSING') return 'badge--processing';
    return 'badge--queue';
  }
}
